import { dataCircleRotation } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCircleRotation = /*#__PURE__*/createIcon(dataCircleRotation)
export default IconCircleRotation
